import { TextField } from "@mui/material";
import { Controller, get, useFormContext } from "react-hook-form";

const FieldLabel = ({ label, required }) => (
  <span>
    {label}
    {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
  </span>
);

const FormControlInput = ({ name, label, required, control: controlProps, type = "text", stableHelperHeight, slotProps: userSlotProps, hiddenHelperText = false, ...props }) => {
  const { control: controlContext } = useFormContext();

  const control = controlProps || controlContext;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => {
        const error = get(errors, name);
        return (
          <TextField
            {...props}
            fullWidth
            label={
              !!label ? (
                <FieldLabel
                  label={label}
                  required={required}
                />
              ) : null
            }
            type={type}
            value={field.value}
            onChange={(event) => field.onChange(type === "number" ? Number(event.target.value) : event.target.value)}
            error={!!error}
            helperText={hiddenHelperText ? undefined : stableHelperHeight ? error?.message || "\u00a0" : error?.message}
            slotProps={{
              ...userSlotProps,
              formHelperText: {
                ...userSlotProps?.formHelperText,
                sx: {
                  mx: "0px",
                  ...(stableHelperHeight ? { minHeight: "22px", lineHeight: 1.66, textAlign: "center" } : {}),
                  ...userSlotProps?.formHelperText?.sx,
                },
              },
            }}
            onInput={
              type === "number"
                ? (e) => {
                    if (e.target.value.length > 10) {
                      e.target.value = e.target.value.slice(0, 10);
                    }
                  }
                : undefined
            }
          />
        );
      }}
    />
  );
};

export default FormControlInput;
